$('document').ready(() => {
    if (!document.querySelector('.advantages')) return;

    let swiper = Swiper;
    let init = false;

    function swiperMode() {
        let mobile = window.matchMedia('(min-width: 0px) and (max-width: 767px)');
        if (mobile.matches) {
            if (!init) {
                init = true;
                swiper = new Swiper('.advantages', {
                    enabled: true,
                    slidesPerView: 1,
                    loop: true,
                    pagination: {
                        el: '.advantages__pagination',
                    },
                    breakpoints: {
                        768: {
                            enabled: false,
                        },
                    }
                });
            }
        } else {
            if (swiper.destroy) {
                swiper.destroy();
            }
            init = false;
        }
    }

    window.addEventListener('load', swiperMode);
    window.addEventListener('resize', swiperMode);
});
